import 'jquery';
import AuthenticationService from '../services/AuthenticationService';
import { loginRedirect } from '../utilities/login';
import AppService, { Actions, ActionTypes } from './Actions';
import AppStore, { Store, StoreEvents } from './Store';

import 'react-datepicker/dist/react-datepicker.css';

declare global {
    var log;
    var App: Actions;
    var AppStore: Store;
    var AppStoreEvents;
    var AppAction;
    var Alert: (options: IAlertDialogOptions) => void;
    var Confirm: (options: IConfirmDialogOptions) => void;
    var Dialog: (options: IDialogOptions) => void;
    var Toast: (message: string | JSX.Element, type: AlertType, duration?: number) => void;
    var Loading: () => { stop: () => void; };
    var CurrentUser: ICurrentUser;
}

window.App = AppService;
window.AppAction = ActionTypes;
window.AppStore = AppStore;
window.AppStoreEvents = StoreEvents;
window.Alert = (options: IAlertDialogOptions) => { AppService.alert(options) };
window.Confirm = (options: IConfirmDialogOptions) => { AppService.confirm(options) };
window.Dialog = (options: IDialogOptions) => { AppService.dialog(options) };
window.Toast = (message: string, type: AlertType, duration?: number) => { AppService.toast(message, type, duration) };
window.Loading = () => { return AppService.loading(); }
window.CurrentUser = null;

const getAuthState = async (): Promise<IAuthenticateState> => {
    return await AuthenticationService.getAuthenticationState();
}

getAuthState().then(authState => {
    if (authState.appId === null || !authState.login) {
        loginRedirect();
        return null;
    }

    import('./Loader');
});